// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bDZP","textarea":"styles_textarea__n4djZ"};